// 图片后缀 mixin
//
// 后缀不再靠运行时猜测，而是由确定规则 + 数据字段决定：
//
//   1) top / face / index / blog / topslide 恒为 jpg
//      实测：top 1254、face 1253、index 19、blog 116、topslide 38，全部是 jpg
//      -> imgUrl(base)
//
//   2) jietu-xx（含 jietu-0，数据里 pic 数组带 0 时会渲染）
//      后缀由 games.json 里的 imgExt 字段决定，没写就是 png
//      -> jietuUrl(base, item.imgExt)
//
//   3) 打赏二维码（dashang）恒为 png，且是固定资源，直接在 Support.vue 里拼

// jietu-xx 未声明 imgExt 时的默认后缀
const JIETU_DEFAULT_EXT = 'png'

export default {
  methods: {
    // 恒为 jpg 的图：game/{path}/top、game/{path}/face、index/{path}、blog/{path}、topslide/{path}
    imgUrl(base) {
      return base + '.jpg'
    },
    // jietu-xx：用数据声明的后缀，没声明则用默认。
    // 例外：jietu-0 恒为 png，不受 imgExt 影响（实测 514 个全是 png）
    jietuUrl(base, ext) {
      if (/\/jietu-0$/.test(base)) return base + '.png'
      return base + '.' + (ext || JIETU_DEFAULT_EXT)
    }
  }
}
